import React, { Fragment, lazy } from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { DigitalDisclaimer } from './DigitalDisclaimer';
import { Zap, UserCheck, ShieldCheck, RefreshCw, Infinity as InfinityIcon, Lock, Check } from 'lucide-react';
interface ProductCard {
  number: string;
  title: string;
  description: string;
  image: string;
  alt: string;
  price: string;
  originalPrice: string;
  buttonText: string;
  url: string;
  highlighted?: boolean;
  premium?: boolean;
  ribbon?: string;
  features?: string[];
  tags?: string[];
}
export function PricingOptions() {
  const products: ProductCard[] = [{
    number: 'PRODUCTO 1',
    title: 'AMAZON FBA DESDE CERO',
    description: 'Aprende a vender en Amazon FBA paso a paso desde cero y descubre cómo crear un negocio online utilizando el sistema logístico de Amazon.',
    image: 'https://cdn.magicpatterns.com/uploads/fRqZGDUfzvBvZ3MhZduMEC/portada_como_vender_en_amazon_comprimida_.png',
    alt: 'Amazon FBA Desde Cero',
    price: '$16.99',
    originalPrice: '$31.65',
    buttonText: 'QUIERO ESTE CURSO',
    url: 'https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-desde-cero-2026-bonos-exclusivos',
    features: ['Cómo funciona Amazon Seller', 'Publicación de productos', 'Investigación de productos', 'Gestión de inventario', 'Optimización de listings', 'Bonos premium incluidos']
  }, {
    number: 'PRODUCTO 2',
    title: 'AMAZON FBM DESDE CERO',
    description: 'Aprende cómo vender en Amazon FBM sin enviar inventario a bodegas FBA y comienza tu negocio con mayor control y flexibilidad.',
    image: 'https://cdn.magicpatterns.com/uploads/j1AcudPF6ryWv1yAHEPiK7/Pottada_FBM.png',
    alt: 'Amazon FBM Desde Cero',
    price: '$15.99',
    originalPrice: '$31.65',
    buttonText: 'QUIERO ESTE CURSO',
    url: 'https://43skvt-1y.myshopify.com/products/aprende-a-vender-en-amazon-fbm-desde-cero',
    features: ['Publicación de productos', 'Gestión manual de pedidos', 'Atención al cliente', 'Estrategias de ventas', 'Optimización básica', 'Bonos premium incluidos']
  }, {
    number: 'PRODUCTO 3',
    title: 'SISTEMA COMPLETO FBA + FBM',
    description: 'Aprende ambos modelos de Amazon paso a paso y descubre cómo vender usando FBA y FBM para tener más oportunidades de crecimiento y escalabilidad.',
    image: 'https://cdn.magicpatterns.com/uploads/m8TmzqT4Ms73kvuSLyKdxi/ChatGPT_Image_16_may_2026,_10_00_02.png',
    alt: 'Sistema Completo Amazon FBA + FBM',
    price: '$27.99',
    originalPrice: '$31.65',
    buttonText: 'QUIERO EL SISTEMA COMPLETO',
    url: 'https://43skvt-1y.myshopify.com/products/sistema-completo-de-ventas-en-amazon-fba-fbm-2026',
    highlighted: true,
    ribbon: '⭐ LA OPCIÓN MÁS ELEGIDA',
    features: ['Amazon FBA desde cero', 'Amazon FBM desde cero', 'Cómo usar Seller Central', 'Publicación de productos', 'Estrategias de ventas', 'Bonos premium incluidos']
  }, {
    number: 'PRODUCTO 4',
    title: 'AMAZON WHOLESALE™ DESDE CERO',
    description: 'Aprende paso a paso cómo vender productos de marcas reconocidas en Amazon utilizando el modelo Wholesale: encuentra proveedores reales, abre cuentas con distribuidores autorizados, analiza rentabilidad y escala un negocio sólido.',
    image: 'https://cdn.magicpatterns.com/uploads/6EaZ8aNCjfA3AUTe9bykTx/principal_wh.png',
    alt: 'Amazon Wholesale Desde Cero',
    price: '$19.99',
    originalPrice: '$67',
    buttonText: 'QUIERO APRENDER WHOLESALE',
    url: 'https://43skvt-1y.myshopify.com/products/como-vender-en-amazon-fba-wholesale-desde-cero-2026',
    ribbon: '🔥 NUEVO PRODUCTO 2026',
    features: ['Cómo funciona Amazon Wholesale', 'Cómo encontrar proveedores reales', 'Cómo abrir cuentas mayoristas', 'Cómo analizar productos rentables', 'Cómo trabajar con marcas reconocidas', 'Estrategias de escalamiento', 'Bonos premium incluidos']
  }, {
    number: '🏆 PRODUCTO MÁS COMPLETO',
    title: 'AMAZON MASTER SYSTEM™ 2026',
    description: 'Incluye los 3 cursos principales más los 2 bonos premium más valiosos para aprender múltiples modelos de venta dentro de Amazon desde una sola plataforma. Ideal para quienes desean comenzar correctamente y tener acceso al ecosistema Amazon más completo de nuestra biblioteca digital.',
    image: 'https://cdn.magicpatterns.com/uploads/bCGUurgwwsLtKUbs28tH1i/ChatGPT_Image_16_jun_2026,_20_06_18.png',
    alt: 'Amazon Master System 2026 - Todo el ecosistema Amazon en un solo sistema',
    price: '$39.99',
    originalPrice: '$79.99',
    buttonText: '🚀 QUIERO AMAZON MASTER SYSTEM™',
    url: 'https://43skvt-1y.myshopify.com/products/amazon-master-system%E2%84%A2-2026-fba-fbm-wholesale-bonos-premium',
    premium: true,
    ribbon: '🚀 Todo el ecosistema Amazon en un solo sistema',
    tags: ['Amazon FBA Desde Cero', 'Amazon FBM Desde Cero', 'Amazon Wholesale Desde Cero', 'Software Stack Amazon™', 'Arbitrage Master™'],
    features: ['Curso Amazon FBA Desde Cero', 'Curso Amazon FBM Desde Cero', 'Curso Amazon Wholesale Desde Cero', 'Bono Software Stack Amazon™', 'Bono Arbitrage Master™', 'Acceso inmediato', 'Descarga digital', 'Actualizaciones futuras']
  }];
  const trustItems = [{
    Icon: Zap,
    text: 'ACCESO INMEDIATO'
  }, {
    Icon: UserCheck,
    text: 'SIN EXPERIENCIA PREVIA'
  }, {
    Icon: RefreshCw,
    text: 'ACTUALIZADO PARA 2026'
  }];
  const bottomTrust = [{
    Icon: Zap,
    title: 'ACCESO INMEDIATO',
    subtitle: 'Recibe tu acceso al instante'
  }, {
    Icon: Lock,
    title: 'PAGO 100% SEGURO',
    subtitle: 'Tus datos están protegidos'
  }, {
    Icon: ShieldCheck,
    title: 'COMPRA 100% SEGURA',
    subtitle: 'Pago protegido y confiable'
  }, {
    Icon: RefreshCw,
    title: 'ACTUALIZACIONES GRATIS',
    subtitle: 'Contenido siempre actualizado'
  }, {
    Icon: InfinityIcon,
    title: 'ACCESO DE POR VIDA',
    subtitle: 'Aprende a tu propio ritmo'
  }];
  return <section className="bg-brand-beige py-20 md:py-24 px-5 sm:px-6" data-id="element-496">
      <div className="max-w-7xl mx-auto" data-id="element-497">
        {/* Header */}
        <FadeIn data-id="element-498">
          <div className="text-center mb-10 md:mb-12 max-w-3xl mx-auto" data-id="element-499">
            <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl font-bold text-brand-green mb-4 tracking-tight leading-[1.1]" data-id="element-500">
              Elige tu mejor opción para empezar hoy
            </h2>
            <p className="text-base md:text-lg text-brand-text/70 leading-relaxed" data-id="element-501">
              Elige el sistema ideal para ti y comienza a construir tu negocio
              online hoy mismo.
            </p>
          </div>
        </FadeIn>

        {/* Trust pill bar */}
        <FadeIn delay={0.1} data-id="element-502">
          <div className="flex justify-center mb-14 md:mb-16 px-2" data-id="element-503">
            <div className="inline-flex flex-wrap items-center justify-center gap-3 sm:gap-2 bg-brand-green rounded-full px-4 sm:px-6 py-3 shadow-[0_15px_40px_-15px_rgba(28,57,40,0.5)] border border-brand-gold/20" data-id="element-504">
              {trustItems.map(({
              Icon,
              text
            }, i) => <Fragment key={i} data-id="element-505">
                  <div className="flex items-center gap-2 px-2 sm:px-3" data-id="element-506">
                    <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-brand-gold/20 border border-brand-gold/40 flex-shrink-0" data-id="element-507">
                      <Icon className="w-3 h-3 text-brand-gold" strokeWidth={2.5} data-id="element-508" />
                    </span>
                    <span className="text-[11px] sm:text-xs font-bold tracking-wider text-white whitespace-nowrap" data-id="element-509">
                      {text}
                    </span>
                  </div>
                  {i < trustItems.length - 1 && <span className="hidden sm:block w-px h-4 bg-white/15" data-id="element-510"></span>}
                </Fragment>)}
            </div>
          </div>
        </FadeIn>

        {/* Product cards grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-7 lg:gap-6 mb-14 items-stretch" data-id="element-511">
          {products.map((product, index) => {
          const isDark = product.highlighted || product.premium;
          return <FadeIn key={index} delay={0.08 * index} data-id="element-512">
                <div className="relative pt-5 h-full" data-id="element-513">
                  {/* Outer premium glow for 3 and 4 */}
                  {product.highlighted && <div className="absolute -inset-2 bg-brand-green/15 blur-2xl rounded-[2rem] pointer-events-none" data-id="element-514"></div>}
                  {product.premium && <div className="absolute -inset-2 bg-brand-gold/20 blur-2xl rounded-[2rem] pointer-events-none" data-id="element-515"></div>}

                  {/* Floating badge */}
                  <div className="absolute top-0 left-1/2 -translate-x-1/2 z-20" data-id="element-516">
                    <div className={`px-5 py-1.5 rounded-full text-[10px] sm:text-xs font-bold tracking-[0.15em] uppercase shadow-lg whitespace-nowrap ${product.premium ? 'bg-brand-gold text-brand-green ring-2 ring-brand-green/10' : product.highlighted ? 'bg-brand-gold text-brand-green ring-2 ring-white/40' : 'bg-brand-green text-white ring-1 ring-brand-gold/30'}`} data-id="element-517">
                      {product.number}
                    </div>
                  </div>

                  {/* Card */}
                  <div className={`relative rounded-3xl h-full flex flex-col overflow-hidden transition-all duration-300 ${product.highlighted ? 'bg-gradient-to-br from-brand-green via-[#102b1e] to-brand-green border-2 border-brand-gold/50 shadow-[0_30px_80px_-20px_rgba(28,57,40,0.6)]' : product.premium ? 'bg-gradient-to-br from-brand-green via-[#0f2a1c] to-brand-green border-2 border-brand-gold shadow-[0_30px_80px_-20px_rgba(200,169,106,0.55)]' : 'bg-white border border-brand-text/8 shadow-[0_8px_30px_-10px_rgba(0,0,0,0.08)]'}`} data-id="element-518">
                    {/* Top gold accent line for dark cards */}
                    {isDark && <div className={`absolute top-0 left-0 right-0 h-1 ${product.premium ? 'bg-gradient-to-r from-brand-gold/40 via-brand-gold to-brand-gold/40' : 'bg-gradient-to-r from-transparent via-brand-gold to-transparent'}`} data-id="element-519"></div>}

                    {/* Image */}
                    <div className={`pt-10 px-5 pb-3 flex items-center justify-center ${isDark ? 'bg-gradient-to-b from-white/8 to-transparent' : 'bg-gradient-to-b from-brand-beige/40 to-transparent'}`} data-id="element-520">
                      <img src={product.image} alt={product.alt} loading="lazy" className="w-full h-auto max-h-[280px] object-contain drop-shadow-2xl" data-id="element-521" />
                    </div>

                    {/* Content */}
                    <div className="px-6 sm:px-7 pb-7 pt-3 flex flex-col flex-1" data-id="element-522">
                      {/* Ribbon — inline pill above title */}
                      {product.ribbon && <div className="flex justify-center mb-3" data-id="element-523">
                          <span className={`inline-flex items-center px-3 py-1 text-[9px] sm:text-[10px] font-bold tracking-[0.15em] uppercase rounded-full shadow-sm whitespace-nowrap bg-brand-gold text-brand-green`} data-id="element-524">
                            {product.ribbon}
                          </span>
                        </div>}

                      {/* Title */}
                      <h3 className={`text-base sm:text-lg font-bold text-center mb-3 leading-tight tracking-tight ${isDark ? 'text-white' : 'text-brand-green'}`} data-id="element-525">
                        {product.title}
                      </h3>

                      {/* Description */}
                      <p className={`text-sm text-center leading-relaxed mb-5 ${isDark ? 'text-white/70' : 'text-brand-text/65'}`} data-id="element-526">
                        {product.description}
                      </p>

                      {/* Tags — value highlights above features */}
                      {product.tags && <div className="flex flex-wrap justify-center gap-2 mb-4" data-id="element-527">
                          {product.tags.map((tag, i) => <span key={i} className={`inline-flex items-center gap-1 text-[10px] sm:text-[11px] font-bold tracking-wide rounded-full px-2.5 py-1 ${isDark ? 'bg-brand-gold/15 text-brand-gold border border-brand-gold/30' : 'bg-brand-green/8 text-brand-green border border-brand-green/15'}`} data-id="element-528">
                              <Check className="w-3 h-3" strokeWidth={3.5} data-id="element-529" />
                              {tag}
                            </span>)}
                        </div>}

                      {/* Feature list */}
                      {product.features && <div className={`mb-6 rounded-xl border p-4 space-y-2 ${product.premium ? 'border-brand-gold/25 bg-white/5' : product.highlighted ? 'border-white/10 bg-white/5' : 'border-brand-text/10 bg-brand-beige/40'}`} data-id="element-530">
                          {product.features.map((f, i) => <div key={i} className="flex items-start gap-2" data-id="element-531">
                              <span className={`inline-flex items-center justify-center w-4 h-4 rounded-full flex-shrink-0 mt-0.5 ${isDark ? product.premium ? 'bg-brand-gold/20' : 'bg-brand-gold/15' : 'bg-brand-green/10'}`} data-id="element-532">
                                <Check className={`w-2.5 h-2.5 ${isDark ? 'text-brand-gold' : 'text-brand-green'}`} strokeWidth={3.5} data-id="element-533" />
                              </span>
                              <span className={`text-[12px] sm:text-[13px] font-medium leading-snug ${isDark ? 'text-white/90' : 'text-brand-text/80'}`} data-id="element-534">
                                {f}
                              </span>
                            </div>)}
                        </div>}

                      {/* Price */}
                      <div className="text-center mb-5 mt-auto" data-id="element-535">
                        <div className="flex items-baseline justify-center gap-3 mb-1" data-id="element-536">
                          <p className={`text-4xl sm:text-5xl font-bold tracking-tight leading-none ${isDark ? 'text-white' : 'text-brand-green'}`} data-id="element-537">
                            {product.price}
                          </p>
                          <p className={`text-lg sm:text-xl line-through font-semibold ${isDark ? 'text-white/35' : 'text-brand-text/40'}`} data-id="element-538">
                            {product.originalPrice}
                          </p>
                        </div>
                        <p className={`text-xs mt-1 ${isDark ? 'text-white/50' : 'text-brand-text/50'}`} data-id="element-539">
                          Pago único
                        </p>
                      </div>

                      {/* Button */}
                      <Button onClick={() => window.open(product.url, '_blank', 'noopener,noreferrer')} className={`w-full text-sm sm:text-[0.95rem] font-bold py-4 ${product.premium ? 'bg-brand-gold hover:bg-brand-gold/90 text-brand-green shadow-lg shadow-brand-gold/30' : product.highlighted ? 'bg-brand-gold hover:bg-brand-gold/90 text-brand-green shadow-lg shadow-brand-gold/25' : ''}`} data-id="element-540">
                        {product.buttonText}
                      </Button>
                    </div>
                  </div>
                </div>
              </FadeIn>;
        })}
        </div>

        {/* Digital products disclaimer */}
        <FadeIn delay={0.35} data-id="element-541">
          <DigitalDisclaimer variant="dark" className="mb-10 text-center" data-id="element-542" />
        </FadeIn>

        {/* Bottom trust strip */}
        <FadeIn delay={0.4} data-id="element-543">
          <div className="bg-white border border-brand-text/8 rounded-2xl shadow-[0_8px_30px_-10px_rgba(0,0,0,0.06)] p-5 sm:p-7" data-id="element-544">
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-5 sm:gap-4" data-id="element-545">
              {bottomTrust.map(({
              Icon,
              title,
              subtitle
            }, i) => <div key={i} className="flex items-center gap-3 min-w-0" data-id="element-546">
                  <span className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-brand-green/8 border border-brand-green/15 flex-shrink-0" data-id="element-547">
                    <Icon className="w-4 h-4 text-brand-green" strokeWidth={2} data-id="element-548" />
                  </span>
                  <div className="min-w-0" data-id="element-549">
                    <p className="text-[11px] sm:text-xs font-bold text-brand-green tracking-wide uppercase leading-tight" data-id="element-550">
                      {title}
                    </p>
                    <p className="text-[10px] sm:text-[11px] text-brand-text/55 leading-tight mt-0.5 truncate" data-id="element-551">
                      {subtitle}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}